import { Button } from "@backpac/monica";
import { OverlayProvider } from "overlay-kit";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router";

export function AppFormLayout() {
  return (
    <OverlayProvider>
      <Helmet>
        <title>Form | Backpac</title>
        <meta name="theme-color" content="#fcfaf5" />
      </Helmet>
      <main className="relative bg-backgroundLight min-h-screen flex flex-col desktop:items-start desktop:justify-start">
        <div className="max-w-[480px] mx-auto mt-16">
          <Outlet />
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center justify-center absolute top-4 right-4"
          onClick={() => window.history.back()}
        >
          <i className="i-bp-close w-4 h-4 inline-block" />
        </Button>
      </main>
    </OverlayProvider>
  );
}
